import { AppState } from '../../app/state/AppState';

export function selectAssetListItems(state: AppState) {
  return state.assetList.items;
}
